import $ from 'jquery';

$(document).on('click', '.hamburger', initHamburger);

function initHamburger() {
    let $mobileNav = $('.mobile-nav');
    let $body = $('body');
    $(this).hasClass('is-active') ? $(this).removeClass('is-active') : $(this).addClass('is-active');
    $mobileNav.hasClass('active') ? $mobileNav.removeClass('active') : $mobileNav.addClass('active');
    $body.hasClass('js-active') ? $body.removeClass('js-active') : $body.addClass('js-active');
}



// WEBPACK FOOTER //
// ./themes/wild/assets/js/hamburger.js